/** Mutual kid card view model rendered on the Co-Guardian Profile screen. */
export type CoGuardianMutualKidVM = {
  id: string;
  name: string;
  /** "Age 8 · Level 3" (falls back to "Level 3" when age is unknown). */
  metaLabel: string;
  /** "Since Sep 2023", omitted when the join date is unknown. */
  sinceLabel?: string;
  age: number | null;
  level: number | null;
  avatarUrl?: string;

  // ─── Player Profile Detail sheet — each omitted when the source field is unset. ───
  /** "15 Jan, 2015". */
  birthdateLabel?: string;
  /** e.g. "Male" / "Female", as returned by the API. */
  genderLabel?: string;
  /** e.g. `48"`. */
  heightLabel?: string;
  /** "Right" / "Left". */
  dominantHandLabel?: string;
  /** Street + city + state, comma-joined; omitted when every part is empty. */
  addressLabel?: string;
  zipcodeLabel?: string;
};

/** Co-Guardian Profile header/identity + mutual kids view model. */
export type CoGuardianProfileVM = {
  guardianUid: string;
  name: string;
  avatarUrl?: string;
  /** Relationship/role label, e.g. "Guardian". */
  roleLabel: string;
  /** "Joined since Sep 2023", omitted when unknown. */
  joinedLabel?: string;
  email?: string;
  mutualKids: CoGuardianMutualKidVM[];
  /** Raw circle role, e.g. "owner" (primary guardian) | "coguardian". */
  role?: string;
};
